module.exports = __webpack_public_path__ + "static/img/zizhi6.0bde21f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zizhi6.jpg
// module id = 2+/Q
// module chunks = 1